import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Handler from "../../../Helpers/Handler";
import "../../../Assets/css/style.css";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";

const EditCommunity = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Expect community data passed via navigate state:
  // navigate("/user/edit-community", { state: { community: { id, name, description, type } } })
  const community = location.state?.community || {};

  const [form, setForm] = useState({
    community_id: community.id || "",
    name: community.name || "",
    description: community.description || "",
    type: community.type || "BUSINESS",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (!community.id) {
      setError("No community data found. Please go back and try again.");
    }
  }, [community.id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleType = (type) => {
    setForm({ ...form, type });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.name.trim()) return setError("Community name is required.");
    if (form.name.trim().length < 3) return setError("Name must be at least 3 characters.");
    if (!form.community_id) return setError("Community ID missing.");

    setLoading(true);
    const res = await Handler({
      method: "POST",
      url: "/communities/update.php",
      data: {
        community_id: parseInt(form.community_id),
        name: form.name.trim(),
        description: form.description.trim(),
        type: form.type,
      },
    });
    setLoading(false);

    if (res.success) {
      setSuccess("Community updated successfully!");
      setTimeout(() => navigate(-1), 1400);
    } else {
      setError(res.message || "Failed to update community.");
    }
  };

  return (
    <MainLayout>
      <FeedLayout>
        <div className="comm-page">
          <div className="comm-header">
            <h2>Edit Community</h2>
            <button className="back-btn" onClick={() => navigate(-1)}>
              <i className="bx bx-arrow-back" /> Back
            </button>
          </div>

          <div className="comm-card" style={{ maxWidth: 540 }}>
            {error && <div className="comm-alert error"><i className="bx bx-error-circle" />{error}</div>}
            {success && <div className="comm-alert success"><i className="bx bx-check-circle" />{success}</div>}

            <form className="comm-form" onSubmit={handleSubmit}>
              {/* Name */}
              <div className="form-group">
                <label>Community Name *</label>
                <input
                  className="form-control"
                  name="name"
                  placeholder="Community name"
                  value={form.name}
                  onChange={handleChange}
                  maxLength={80}
                />
              </div>

              {/* Description */}
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  placeholder="Update description…"
                  value={form.description}
                  onChange={handleChange}
                  rows={3}
                />
              </div>

              {/* Type Toggle */}
              <div className="form-group">
                <label>Community Type</label>
                <div className="type-toggle-group">
                  {["BUSINESS", "EVENT"].map((t) => (
                    <button
                      key={t}
                      type="button"
                      className={`type-toggle-btn${form.type === t ? " active" : ""}`}
                      onClick={() => handleType(t)}
                    >
                      <i className={`bx ${t === "BUSINESS" ? "bx-briefcase" : "bx-calendar-event"}`} />{" "}
                      {t.charAt(0) + t.slice(1).toLowerCase()}
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8, flexWrap: "wrap" }}>
                <button type="button" className="comm-btn-outline" onClick={() => navigate(-1)}>
                  Cancel
                </button>
                <button type="submit" className="comm-btn-primary" disabled={loading || !community.id}>
                  {loading ? <><i className="bx bx-loader-alt bx-spin" /> Saving…</> : <><i className="bx bx-save" /> Save Changes</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      </FeedLayout>
    </MainLayout>

  );
};

export default EditCommunity;